import { render } from "./zyjs.vue?vue&type=template&id=ae6feace&scoped=true&ts=true"
import script from "./zyjs.vue?vue&type=script&lang=ts"
export * from "./zyjs.vue?vue&type=script&lang=ts"

import "./zyjs.vue?vue&type=style&index=0&id=ae6feace&lang=less&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ae6feace"]])

export default __exports__